import { FINANCE_V2_HOSTNAME } from "../../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../../common-utilities/utils/end-points/finance-v2";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";

// Same underlying location/list route PoFilters' locationList() and
// create-pr's loadStores() already call — additionalFields:"region" is the
// only addition, so the Store dropdown can also drive the Region cascade.
export const storeRegionList = (setDataFunc) => {
  invokeApi(
    HTTP_METHODS.GET,
    `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_LOCATION_LIST}`,
    null,
    { poBudgetLocations: true, additionalFields: "region" }
  )
    .then((response) => {
      const results =
        response?.map?.((item) => ({
          label: `${item.name}${item.code ? ` - ${item.code}` : ""}`,
          value: item.id,
          region: item.region,
        })) || [];
      setDataFunc(results);
    })
    .catch(() => {});
};
